var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditPen = function SvgEditPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m42 13.515-4 4V8H20v10H10v22h28v-5.515l4-4v11.531C42 43.112 41.11 44 40.013 44H7.987C6.89 44 6 43.1 6 41.986V16L18.006 4h21.99C41.103 4 42 4.91 42 5.984z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F80",
    d: "m46.385 20.444-2.829-2.829L28 33.172l-.004 2.824 2.832.004z"
  })));
};
export default SvgEditPen;